<template>
 <v-alert text color="deep-orange">
    <span>
        {{ message }}
    </span>
    <span>
        <v-btn text outlined color="deep-orange" @click="submit()">
            Create
        </v-btn>
    </span>
</v-alert>
</template>

<script>
import API from '@/api';
const User = API.get('User');

export default {
    props: {
        user: {
            type: Object,
            default: () => {
                /**
                 * email
                 * mobile
                 */
                return {};
            }
        }
    },

    data: () => ({
        message: "User not found! Do you want to create user?",
        // email: "testUser20@fourello.com"
    }),

    methods: {
        async submit() {

            let form = {
                username:                       this.user.Email,
                email:                          this.user.Email,
                password:                       this.user.MobileNumber,
                full_name:                      this.user.FullName,
                mobile_number:                  this.user.MobileNumber,
                is_patient:                     true,
                height:                         this.user.Height,
                weight:                         this.user.Weight,
                
                // 1 male
                // 2 female
                gender:                         this.user.Gender,
                
                // 1 yung single
                // 2 married
                // 3 divorced
                // 4 widowed
                marital_status:                 this.user.CivilStatus,


                alternate_email:                this.user.AlternativeEmail,
                preferred_language:             this.user.Language,

                has_warning:                    this.user.Warning,
                warning_reason:                 this.user.WarningReason,
                period_last_start:              this.user.LatestMenstruationStartDate,

                operations:                     this.user.Operations,
                hospitalizations:               this.user.Hospitalisations,
                immunizations:                  this.user.ImmunizationStatus,
                dietary_status:                 this.user.DietaryStatus,

                birth_date:                     this.user.Birthday,
                
                company_name:                   this.user?.NameOfCompany,
                date_measured:                  this.user?.DateMeasured,
                
                allergies:                      this.user?.Allergies,
                illnesses:                      this.user?.Illnesses,
                family_history:                 this.user?.FamilyHistory,
                vices:                          this.user?.Vices,
                
                insurance_provider:             this.user?.HealthInsurance,
                insurance_number:               this.user?.HealthInsuranceProviderNumber,

                email_options:                  this.user?.email_options,
                phonenumber_options:            this.user?.phonenumber_options,
                crm_id:                         this.user?.PatientId,
                pms_guid:                       this.user?.PatientGuid
            };
            
            let apiResponse = {};

            /* ################################################## METHOD SEPARATORS ################################################## */

            console.log("[user create payload]", form);

            await User.createUser(form)
            .then(response => {
                console.log({ response })
                apiResponse = {
                    response: response.data,
                    success: true
                }
            })
            .catch(error => {
                console.log(error.response.data)
                let objectKey = Object.keys(error.response.data.errors)
                console.log({ objectKey }, objectKey[0])
                this.message = error.response.data.errors[objectKey[0]][0];
                apiResponse = {
                    response: null,
                    success: false
                }
            });

            /* ################################################## METHOD SEPARATORS ################################################## */

            await this.$emit('submit', apiResponse);
        }
    }
}
</script>